import { defineComponent, Fragment } from "vue";
import { hasPageAuth } from "@/router/utils";

export default defineComponent({
  name: "AuthPage",
  props: {
    value: {
      type: undefined,
      default: []
    }
  },
  setup(props, { slots }) {
    return () => {
      if (!slots) return null;
      return hasPageAuth(props.value) ? (
        <Fragment>{slots.default?.()}</Fragment>
      ) : null;
    };
  }
});
